import styled from 'styled-components';

export const StyledContainer = styled.div`
    justify-content: center;
    display: flex;
    height: 300px;
    padding-top: 150px;
`;
